import {
  EmptyState,
  EmptyStateDescription,
  EmptyStateIllustration,
  EmptyStateTitle,
} from '@/components/EmptyState'
import { byDesign } from '@/infra/design'
import imgGetStartedUrl from '@/assets/misc/img_get-started.svg'
import CreateTeamIllustration from '@/components/SpotIllustration/CreateTeamIllustration'

export interface OCRScopeJobUnderReviewProps {
  fileName: string
}

export function OCRScopeJobUnderReview({
  fileName,
}: OCRScopeJobUnderReviewProps) {
  return (
    <EmptyState size="sm">
      <EmptyStateIllustration
        src={imgGetStartedUrl}
        illustration={byDesign(undefined, CreateTeamIllustration)}
      />
      <EmptyStateTitle>OCR scoping requires review</EmptyStateTitle>
      <EmptyStateDescription>
        There seems to be an issue scoping <b>{fileName}</b> at the moment. Our
        team is aware of the problem and will update the job on your behalf.
      </EmptyStateDescription>
    </EmptyState>
  )
}
